export const computeSubtotal = (price: number, quantity: number) => {
  const subtotal = Number.isFinite(price) && Number.isFinite(quantity) ? price * quantity : 0;
  return parseFloat(subtotal.toFixed(2));
};

export const computeTotal = (subtotal: number, tax: number) => {
  let total = Number.isFinite(tax) ? subtotal + tax : 0;
  if (Number.isNaN(total)) {
    total = 0;
  }
  return parseFloat(total.toFixed(2));
};
